import React from 'react';
import DesignPage from '../components/DesignPage';

const Contact = () => <DesignPage page="contact" />;

export default Contact;
